<template>
    <div class="page">
        <div class="main_body">
            <div class="top_label">
                <span class="top_table_name">班级管理</span>
                <el-row>
                    <el-button size="small" type="primary" icon="el-icon-link" @click="pushPlan">加入班级</el-button>
                    <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="addPlan(1)" plain>创建班级</el-button> -->
                </el-row>
            </div>

            <div class="plan_label_box">
                <div class="plan_label_button_box">
                    <span @click="handleClick(0)" :class="['plan_label_box_button',{plan_label_box_button_active:form_data.state==0}]">当前班级</span>
                    <span @click="handleClick(1)" :class="['plan_label_box_button',{plan_label_box_button_active:form_data.state==1}]">历史班级</span>
                </div>
                <el-input
                    placeholder="请输入班级名称"
                    style="width: 300px;"
                    :clearable="true" 
                    @input="changKeyword"
                    v-model="keyword">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </div>

            <div class="plan-grid-container">

                <div v-for="(item,index) in plan_data" :key="index" class="plan-grid-item">
                    <div class="top_image">
                        <img src="../../../static/image/plan_icon.png" />
                    </div>
                    <div class="plan_info_box">
                        <div class="plan_name_box">
                            <span class="left">{{ item.name }}</span>
                            <span class="right">{{ item.status?'独立班':'自然班' }}</span>
                        </div>
                        <span class="plan_info_list">
                            
                            年级：{{ item.grade_text }} 学院：{{ item.college }}
                        </span>
                        <span class="plan_info_list">
                            
                            老师：{{ item.u_id_text }}
                        </span>
                        <span class="plan_info_list">
                            
                            人数：{{ item.number }}人
                        </span>
                        <span class="plan_info_list">
                            
                            班级码：{{ item.qcode }}
                        </span>
                        <span v-if="item.remark" class="plan_info_list" style="color:#F56C6C">
                            
                           备注：{{ item.remark }}
                        </span>
                    </div>
                    <div class="plan_button_box" v-if="form_data.state == 0">
                        <el-button @click="planDetail(item.plan_id)" size="large" type="primary">查看班级</el-button>
                        <!-- <el-button @click="cockpit(item.plan_id)" size="large" type="primary" class="el-icon-s-data"> 学情分析</el-button> -->
                        <div @click="showRemark(item)" class="MoreFilledbox remark_button">
                            <i class="el-icon-edit"></i>
                            <span>备注</span>
                        </div>

                        <span @click="deletePlan(item.id)" class="MoreFilledbox">
                            <i class="el-icon-delete"></i>
                        </span>
                        
                    </div>
                    <div class="remove_plan_button_box" v-if="form_data.state == 1">
                        <el-button @click="recovery(item.plan_id)" size="large" type="primary">恢复班级</el-button>

                        <span @click="deletePlan(item.id)" class="MoreFilledbox">
                            <i class="el-icon-delete"></i>
                        </span>
                        
                    </div>
                </div>
                
                <div v-if="form_data.state == 0" style="postion:relative;border:2px dashed #e5e7eb" class="plan-grid-item">
                    <div class="plan_add_box">
                        
                        <i style="font-size:28px" class="el-icon-message-solid"></i>
                    </div>
                    <span class="plan_add_info" style="font-weight: 700;">暂无更多班级</span>
                    <span style="font-size:14px;color:#6b7280" class="plan_add_info">点击下方按钮创建新的班级</span>

                    <el-button @click="addPlan(1)" class="add_button" size="large" type="primary" icon="el-icon-plus">创建班级</el-button>
                </div>
            </div>
            <div v-if="plan_data.length == 0 && form_data.state == 1" class="plan-empty-item">
                <el-empty description="暂无历史班级"></el-empty>
            </div>
            <!-- hide-on-single-page -->
            <div class="pagination_box">
                <el-pagination
                hide-on-single-page
                    background
                    layout="prev, pager, next"
                    @size-change="changeSize"
                    @current-change="changeNumber"
                    @prev-click="prev"
                    @next-click="next"
                    :page-size="form_data.pageSize"
                    :total="total_number">
                </el-pagination>
            </div>
        </div>
        <div class="dialog_">
            <el-dialog title="加入班级" width="50%" :visible.sync="dialogFormVisible">
                <el-form size="small" :model="form">
                    <el-form-item label="" :label-width="formLabelWidth">
                        <el-input v-model="form.qcode" @input="serachPlan" placeholder="输入班级码"></el-input>
                        <!-- <el-button class="search_button" type="primary">搜索</el-button> -->
                    </el-form-item>
                    
                </el-form>
                
                <el-table size="medium" :data="tableData" style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="班级名称">
                    </el-table-column>
                    <el-table-column
                        prop="u_id_text"
                        label="管理班级">
                    </el-table-column>
                    <el-table-column
                        prop="grade_text"
                        label="年级">
                    </el-table-column>
                    <el-table-column
                        prop="college"
                        label="学院">
                    </el-table-column>
                    <el-table-column
                        prop="specialty"
                        label="专业">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
    
                            <el-button
                            size="mini"
                            type="primary"
                            @click="handleCreate(scope.$index, scope.row)">加入</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
        </div>
        <!-- 创建班级 -->
        <div class="dialog_add">
            <el-dialog :title="`${add_type == 1?'创建班级':'修改信息'}`" width="400px" @close="dialogAddColose" :visible.sync="dialogFormAdd">
                <el-form :model="add_data">
                    <el-form-item label="班级" label-position="top">
                        <el-input v-model="add_data.name" placeholder="输入班级名称"></el-input>
                    </el-form-item>
                    <el-form-item label="年级" label-position="top">
                        <el-select v-model="add_data.grade" placeholder="请选择年级">
                            
                            <el-option v-for="(item,index) in grade_data" :key="index" :label="item" :value="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学院" label-position="top">
                        <el-input v-model="add_data.college" placeholder="输入学院名称"></el-input>
                    </el-form-item>
                    <el-form-item label="专业" label-position="top">
                        <el-input v-model="add_data.specialty" placeholder="输入专业名称"></el-input>
                    </el-form-item>
                    <el-form-item label="类型" label-position="top">
                        <el-select v-model="add_data.status" placeholder="请选择班级类型">
                            <el-option label="自然班级" value="0"></el-option>
                            <el-option label="独立班级" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormAdd = false">取消</el-button>
                    <el-button type="primary" icon="el-icon-edit" @click="addForm">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="remarkDialog">
            <el-dialog title="填写备注" width="500px" :visible.sync="remarkDialog">
                <el-input
                    type="textarea"
                    :rows="20"
                    placeholder="请在此处填写备注"
                    v-model="remark">
                    </el-input>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" style="margin-top: 20px;display: inline-block;" icon="el-icon-edit" @click="submitRemark">确认提交</el-button>
                    </div>
                    
            </el-dialog>
        </div>
        
    </div>
</template>
  
<script>
    import Http from "../../apis/teach";
    import skeleton from "../../../untils/skeleton.vue";
    export default{
        components:{
            'Skeleton':skeleton
        },
        data(){

            return{
                remarkDialog:false,
                remark:'',
                loading:true,
                disabled:false,
                upload_path:`${this.$Config.baseUrl}/api/common/upload`,
                upload_data:{},
                activeName:'first',
                keyword:'',
                dialogFormVisible:false,
                dialogVisible:false,
                dialogImageUrl:'',
                form:{
                    qcode:''
                },
                add_data:{

                },
                formLabelWidth:'0px',
                tableData: [],
                dialogFormAdd:false,
                addformLabelWidth:'3vw',
                plan_data:[],
                form_data:{
                    page:1,
                    pageSize:7,
                    state:0
                },
                total_number:0,
                grade_data:[],
                image:[],
                add_type:1,
                plan_id:0
            }
        },
        computed: {  
            
        },  

        created(){
            
            var params = {}
            params.token = window.sessionStorage.getItem("token")
            this.upload_data = params
            this.getList()
            this.getYear_()
        },

        methods:{
            submitRemark(){
                var params = {}
                params.remark = this.remark
                params.plan_id = this.plan_id
                Http.addremark(params).then((res) => {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: res.code ? 'success' : 'error'
                    });
                    this.remarkDialog = false;
                    if(res.code){
                        this.getList()
                    }
                });
            },
            showRemark(item){
                this.remarkDialog = true
                this.plan_id = item.id
            },
            handlePopState(){
                document.body.style.overflow = 'auto';
            },
            // 获取年级
            getYear_(){
                Http.getYear().then((res) => {
                    this.grade_data = res.data
                });
            },
            
            // 获取班级列表
            // state 0 管理中的班级码历史班级
            getList(){
                // const loading = this.$loading({
                //     lock: true,
                //     text: '疯狂加载中..',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.5)'
                // });
                var params = this.form_data
                params.keyword = this.keyword
                Http.PlanList(params).then((res) => {
                    this.loading = false;
                    //loading.close()
                    this.plan_data = res.data.list
                    this.total_number = res.data.count
                });
            },

            // 上一?

            prev(e){
                this.form_data.page = e
                this.getList()
            },

            // 下一?
            next(e){
        
                this.form_data.page = e
                this.getList()
            },

            // 点击页码
            changeNumber(e){
                this.form_data.page = e
                this.getList()
            },

            // 前往指定页数
            changeSize(e){
                this.form_data.page = e
                this.getList()
            },

            // 切换班级列表
            // tab.index 0 现在管理班级 1历史班级
            handleClick(index){
                this.form_data.state = index
                this.getList();
            },

            // 搜索班级
            changKeyword(value){
                this.form_data.keyword = value
                this.getList();
            },

        
            //加入班级 - 按班级码搜索班级
            
            serachPlan(value){
  
                var params = this.form
                params.qcode = value
                Http.getPlan(params).then((res) => {
      
                    this.tableData = res.data
                });
         
            },
            // 加入班级
            handleCreate(index,item){
                var params = {}
                params.plan_id = item.id
                Http.pushPlan(params).then((res) => {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: res.code ? 'success' : 'error'
                    });
                    this.dialogFormVisible = false
                    if(res.code){
                        this.getList()
                    }
                });
            },

            // checkImg(thumb){
            //     var row = {}
            //     row.name = ''
            //     row.url = thumb
            //     var image = []
            //     image.push(row)
            //     this.image = image
            //     this.add_data.image = thumb
            // },

            // 图片上传成功回调
            handleSuccess_(e){
                var row = {}
                row.name = ''
                row.url = e.data.fullurl
                var image = []
                image.push(row)
                this.image = image
                this.add_data.image = e.data.url
            },

            //提交保存

            addForm(){
                // 添加
                if(this.add_type == 1){
                    this.create()
                }else{
                    // 修改
                    this.edit()
                }
            },

            create(){
                Http.createPlan(this.add_data).then((res) => {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: res.code ? 'success' : 'error'
                    });
                    this.dialogFormAdd = false
                    this.getList()
                });
            },

            edit(){

                var params = this.add_data
                params.plan_id = this.plan_id
                Http.updatePlan(params).then((res) => {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: res.code ? 'success' : 'error'
                    });

                    this.add_data = {}
                    this.image = []
                    this.dialogFormAdd = false
                    this.getList()
                });
            },

            // type 1 创建班级
            addPlan(type){
                this.add_type = type
                this.dialogFormAdd = true
            },
            pushPlan(){
                this.dialogFormVisible = true
            },

            planDetail(plan_id){
                var _this = this
                _this.$router.push({name:'PlanDetail',query:{plan_id:plan_id}});
            },
            // 学情分析
            cockpit(plan_id){
                var _this = this
                _this.$router.push({name:'TeachCockpit',query:{plan_id:plan_id}});
            },
            // 删除班级
            deletePlan(plan_id){

                var diao_str = this.form_data.state == 0?
                '删除后可在历史班级中恢复, 是否继续?'
                :'从历史班级中删除后不可恢? 是否继续?';

                this.$confirm(diao_str, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var params = {}
                    params.plan_id = plan_id
                    params.state = this.form_data.state
                    Http.delPlan(params).then((res) => {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: res.code ? 'success' : 'error'
                        });
                        this.getList()
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '操作已取消'
                    });          
                });
            },

            
            // 班级信息回显 type 2修改班级信息
            editPlan(plan_id,type){
                this.plan_id = plan_id
                this.add_type = type
                var params = {}
                params.plan_id = plan_id
                Http.getDetail(params).then((res) => {

                    var add_data = {}
                    add_data.college = res.data.college
                    add_data.grade = res.data.grade.toString()
                    add_data.status = res.data.status.toString()
                    add_data.image = res.data.image
                    add_data.name = res.data.name
                    add_data.specialty = res.data.specialty
                    console.log(add_data)
                    this.add_data = add_data


                    this.$Common.reconsitution(res.data,'plan_detail')
                    var row = {}
                    row.name = ''
                    row.url = res.data.image
                    var image = []
                    image.push(row)
                    this.image = image
                    this.dialogFormAdd = true
                });
            },

            // 关闭创建、修改窗口回?
            dialogAddColose(){
                this.add_data = {}
                this.image = []
            },

            // 恢复班级
            recovery(plan_id){

                var params = {}
                params.plan_id = plan_id
                Http.recoveryPlan(params).then((res) => {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: res.code ? 'success' : 'error'
                    });
                    this.getList()
                });

            }
        }
    }

</script>
<style scoped>
    .dialog_ >>> .el-table thead{
        color: #000000;
    }
    .paln_page >>> .el-main{
        background: #ffffff !important;
        margin: 20px;
        border-radius: 8px;
    }
    .top_label{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        padding: 20px;
        border-radius: 8px;
        box-sizing: border-box;
        box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    }
    .top_table_name{
        font-size: 18px;
        font-weight: bold;
    }

    .plan-grid-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 30px; /* 设置间距为20px */
    width: 100%;
    margin-top: 30px;
}

.plan-grid-item {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.15);
    transition: transform 0.3s ease;
}
.plan-grid-item:hover {
    transform: translateY(-10px);
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.15);
}
.plan-empty-item{
    display: flex;
    justify-content: center;
    align-items: center;
}
.top_image{
    width:100%;
    height:192px;    
    background-image: linear-gradient(to bottom right, rgb(64 158 255 / 0.3) , rgb(64 158 255 / 0.1));
    position: relative;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
.top_image img {
    width: 90px;
    height: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.plan_info_box{
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    padding: 15px;
}
.plan_name_box{
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 15px;
}
.plan_name_box .left{
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    text-align: left;
}
.plan_name_box .right{
    font-size: 12px;
    color: #000000;
    padding: 5px 10px;
    background: #DCFCE7;
    color: #166534;
    border-radius: 20px;
}
.plan_info_list{
    width: 100%;
    display: inline-block;
    text-align: left;
    margin-bottom: 10px;
    font-size: 14px;
}
.plan_info_list :deep(.el-icon){
    float: left;
    margin-right: 5px;
}
.plan_button_box{
    display: grid;
    grid-template-columns: 1fr 68px 50px;
    gap: 4px;
    padding: 12px;
    box-sizing: border-box;
    width: 100%;
}
.remove_plan_button_box{
    display: grid;
    grid-template-columns: 1fr 68px;
    gap: 4px;
    padding: 12px;
    box-sizing: border-box;
    width: 100%;
}

.plan_button_box > *{
    min-width: 0;
    box-sizing: border-box;
}
.plan_button_box .el-button{
    width: 100%;
    margin-left: 0;
    padding-left: 8px;
    padding-right: 8px;
}

.MoreFilledbox{
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px #e5e7eb solid;
    border-radius: 5px;
    cursor: pointer;
}
.MoreFilledbox:hover{
    color: #FF523F;
}
.MoreFilledbox >>> .el-icon-delete{
    font-size: 22px;
}
.plan_add_box{
    background: #F3F4F6;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    margin: 0 auto;
    line-height: 114px;
    margin-top:50px;
}
.plan_add_info{
    width: 100%;
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
    padding: 0px 20px;
    margin-top: 20px;
}
.add_button{
    margin-top: 40px;
    margin-bottom: 139px;
}
.remark_button{
    font-size:14px !important;
    display: flex;
    align-items: center;
    gap: 3px;
}
.remark_button >>> .el-icon-edit{
    margin-top:2px;
}

.plan_label_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    margin-top: 25px;
}
.plan_label_button_box{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
}
.plan_label_box_button{
    border: 1px #e5e7eb solid;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
}

.plan_label_box_button:hover{
    color: #fff;
    background: #409EFF;
}
.plan_label_box_button_active{
    color: #fff;
    background: #409EFF;
    border: 1px #409EFF solid;
}

.dialog_add >>> .el-dialog__header{
    text-align: left;
}

.dialog_add >>> .el-dialog__title{
	font-weight: bold;
	font-size: 16px;
}
.dialog_add >>> .el-dialog{
	border-radius: 10px;
}
.dialog_add >>> .el-select{
    width: 100%;
}
.dialog_add >>> .el-form-item{
    margin-bottom: 0px !important;
}

.remarkDialog >>> .el-dialog__header{
    text-align: left;
}

.remarkDialog >>> .el-dialog__title{
	font-weight: bold;
	font-size: 16px;
}
.remarkDialog >>> .el-dialog{
	border-radius: 10px;
}


.dialog_ >>> .el-dialog__header{
    text-align: left;
}

.dialog_ >>> .el-dialog__title{
	font-weight: bold;
	font-size: 16px;
}
.dialog_ >>> .el-dialog{
	border-radius: 10px;
}


.pagination_box{
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
    margin-top: 10px;
}



</style>
